/**
 * Parse and format length × width in feet for listing `size` text and spec attributes.
 */

export type DimensionsFtParsed = {
  length: number;
  width: number;
  height?: number;
};

function parseFiniteNumber(input: string): number | null {
  const n = Number.parseFloat(input);
  return Number.isFinite(n) ? n : null;
}

/** Parses strings like "4 x 6", "4.5ft x 6ft", "4 ft by 6 ft". */
export function parseDimensionsFtText(text: string): DimensionsFtParsed | null {
  const trimmed = text.trim();
  if (!trimmed) return null;
  const re =
    /(\d+(?:\.\d+)?)\s*(?:ft|feet|')?\s*(?:x|by)\s*(\d+(?:\.\d+)?)\s*(?:ft|feet|')?(?:\s*(?:x|by)\s*(\d+(?:\.\d+)?)\s*(?:ft|feet|')?)?/i;
  const m = trimmed.match(re);
  if (!m) return null;
  const length = parseFiniteNumber(m[1] ?? "");
  const width = parseFiniteNumber(m[2] ?? "");
  const height = m[3] ? parseFiniteNumber(m[3]) : null;
  if (length === null || width === null) return null;
  if (height !== null) return { length, width, height };
  return { length, width };
}

/** Rounds a positive finite length/width for display in numeric fields. */
export function formatDimensionInputNumber(n: number): string {
  if (!Number.isFinite(n) || n <= 0) return "";
  return Number.isInteger(n) ? String(Math.round(n)) : String(n);
}

/** Canonical listing string for titles and attribute derivation (length × width only). */
export function formatDimensionsFtListing(
  length: number,
  width: number,
): string {
  const a = formatDimensionInputNumber(length);
  const b = formatDimensionInputNumber(width);
  if (!a || !b) return "";
  return `${a} ft x ${b} ft`;
}
